import React from 'react'
import { useSelector } from 'react-redux'
import BlogsGridNews from './BlogsGridNews';
import ListViewBlogsGrid from './ListViewBlogsGrid';
import TimelineBlogsList from './TimelineBlogsList';
import BlogListing from './BlogListing';
import SecondBlogsGrid from './SecondBlogsGrid';

function BlogsHomeWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_blog === "grid" ? (
        <BlogsGridNews />
      ) : sitedata?.theme_blog === "list" ? (
        <ListViewBlogsGrid />
      ) : sitedata?.theme_blog === "time-line" ? (
        <TimelineBlogsList />
      ) : sitedata?.theme_blog === "static-card-grid" ? (
        <BlogListing />
      ) : (
        <SecondBlogsGrid />
      )}
    </>
  )
}

export default BlogsHomeWrapper;